import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getLanding as getLandingApi,
  addNewLanding as addNewLandingApi,
  updateLanding as updateLandingApi,
  deleteLanding as deleteLandingApi,
} from "../../helpers/realbackend_helper";

export const getLanding = createAsyncThunk("landing/getLanding", async () => {
  try {
    const response = await getLandingApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewLanding = createAsyncThunk(
  "landing/addNewLanding",
  async (landing) => {
    try {
      const response = addNewLandingApi(landing);
      toast.success("Мэдээллийг амжилттай хадгаллаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Мэдээллийг хадгалахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateLanding = createAsyncThunk(
  "landing/updateLanding",
  async (landing) => {
    try {
      const response = updateLandingApi(landing);
      toast.success("Мэдээллийг амжилттай хадгаллаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Мэдээллийг хадгалахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteLanding = createAsyncThunk(
  "landing/deleteLanding",
  async (id, { rejectWithValue }) => {
    try {
      await deleteLandingApi(id);

      toast.success("Мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);
